import { render } from "./btn-fluorescence-one.vue?vue&type=template&id=beafd394&scoped=true"
import script from "./btn-fluorescence-one.vue?vue&type=script&lang=js"
export * from "./btn-fluorescence-one.vue?vue&type=script&lang=js"

import "./btn-fluorescence-one.vue?vue&type=style&index=0&id=beafd394&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-beafd394"

export default script